import React from 'react';
import { Box, NavigationLink } from '../../../design-system';
import { handleProductClick } from './handlers/navigationHandlers';
import { NAV_PRODUCT } from '../constants/landingText';

const NavLinks: React.FC = () => {
  return (
    <Box
      component="nav"
      sx={{
        display: { xs: 'none', md: 'flex' },
        gap: '2rem',
        alignItems: 'center',
        marginLeft: { md: '2rem' },
      }}
      aria-label="Main navigation"
    >
      <NavigationLink onClick={handleProductClick}>
        {NAV_PRODUCT}
      </NavigationLink>
    </Box>
  );
};

export default NavLinks;
